export const RECENTLY_SEARCH_NUMBERS = 6;
